export const getSingleValue = <T,>(data: T | T[]) => {
    if(Array.isArray(data)) {
        return data[0];
    }else
        return data as T;
}